import { render } from "./TrainersSection.vue?vue&type=template&id=387ce684&scoped=true"
import script from "./TrainersSection.vue?vue&type=script&lang=js"
export * from "./TrainersSection.vue?vue&type=script&lang=js"

import "./TrainersSection.vue?vue&type=style&index=0&id=387ce684&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387ce684"]])

export default __exports__